import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { motion } from "motion/react";
import servicesData from "../../data/servicesData.json";

const Deliverables = () => {
    const getImage = (imageName) => {
        return require(`../../assets/${imageName}`)
    }

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    }

    const cardVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: { duration: 0.5, ease: "easeOut" }
        }
    }

    return (
        <section className="section-lg bg-light overflow-hidden" id="growth-services">
            <Container>
                <Row>
                    <Col xs={12} className='mb-5'>
                        <motion.h6 initial={{ opacity: 0, y: -30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="underline-after position-relative text-center z-0">
                            <span className="position-relative z-1 bg-white text-primary px-3">What We Deliver</span>
                        </motion.h6>
                        <motion.h1 initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="d-block text-gradiant text-center fw-semibold">Acquisition, Activation, Retention</motion.h1>
                    </Col>
                </Row>
                <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <Row>
                        {servicesData.deliverables.map((deliverable) => (
                            <Col lg={4} md={6} xs={12} className="mb-4" key={deliverable.id}>
                                <motion.div variants={cardVariants}
                                    whileHover={{ y: -10, scale: 1.03, transition: { duration: 0.3 } }}
                                >
                                    <Card className={`h-100 service-card overflow-hidden rounded-1 position-relative ${deliverable.cardClass}`}>
                                        <Card.Body>
                                            <motion.img src={getImage(deliverable.image)} alt={deliverable.title} className="card-icon my-3"
                                                whileHover={{ rotate: 5, scale: 1.1 }}
                                                transition={{ duration: 0.3 }}
                                            />
                                            <h5 className="mb-2">{deliverable.title}</h5>
                                            <p className="text-secondary">{deliverable.description}</p>
                                            <ul className="list-unstyled lh-lg mb-0">
                                                {deliverable.items.map((item, idx) => (
                                                    <motion.li key={idx} className="item-list"
                                                        initial={{ opacity: 0, x: -10 }}
                                                        whileInView={{ opacity: 1, x: 0 }}
                                                        viewport={{ once: true }}
                                                        transition={{ delay: idx * 0.1 + 0.3 }}
                                                    >
                                                        <i className="ri-checkbox-circle-fill"></i> {item}
                                                    </motion.li>
                                                ))}
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </motion.div>
            </Container>
        </section>
    )
}

export default Deliverables;